<template>
  <v-bottom-navigation v-model="value" elevation="1" grow>
    <v-btn
      v-for="option in filteredOptions"
      :key="option.value"
      :value="option.value"
      color="primary"
    >
      <v-icon size="large">{{ option.props?.prependIcon }}</v-icon>
      <span class="mt-1">{{ option.title }}</span>
    </v-btn>
  </v-bottom-navigation>
</template>

<script setup>
  import {
    BOTTOM_NAV_OPTIONS,
    useDevMode,
    usePermissionEvaluator,
  } from '#xapp-core/foundation'
  import { computed, ref, watch } from 'vue'
  import { useRoute, useRouter } from 'vue-router'

  import { resolveNavTarget } from '../../helpers/navTarget'

  const router = useRouter()
  const route = useRoute()
  const { isDevMode } = useDevMode()
  const { hasPermission } = usePermissionEvaluator()

  const value = ref(route.name || route.path)

  const filteredOptions = computed(() =>
    BOTTOM_NAV_OPTIONS.filter((option) => {
      if (option.type === 'subheader' || option.type === 'divider') return false

      // If it's a developer option, only show it when dev mode is on
      if (option.developerOnly) {
        return isDevMode.value
      }

      return hasPermission(option)
    })
  )

  // Update nav when route changes
  watch(
    () => route.name,
    (newName) => {
      value.value = newName || route.path
    }
  )

  // Navigate when nav changes
  watch(value, (newVal) => {
    const selected = filteredOptions.value.find(
      (option) => option.value === newVal
    )
    const target = resolveNavTarget(selected)
    if (!target) return

    const targetPath = target.path
    if (targetPath && targetPath !== route.path) {
      router.push({ path: targetPath })
      return
    }

    if (target.name && target.name !== route.name) {
      router.push({ name: target.name })
    }
  })
</script>
